<template>
    <div class="user-tab-panel">
        <v-row>
            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.password"
                    label="Nova Senha"
                    outlined
                    hide-details="auto"
                    :type="show ? 'text' : 'password'"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.confirmPassword"
                    label="Confirmar Nova Senha"
                    outlined
                    hide-details="auto"
                    :type="show ? 'text' : 'password'"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                />
            </v-col>
        </v-row>

        <div class="user-tab-panel__actions">
            <v-btn
                color="primary"
                @click="save"
                :loading="saving"
            >
                Redefinir Senha
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            saving: false,
            show: false,
            payload: {},
            users: [],
        }
    },
    computed: {
        user: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        load() {
            //
        },
        async save() {
            if (this.payload.password !== this.payload.confirmPassword) {
                this.$toast('error', 'As senhas não coincidem!')
                return
            }

            this.saving = true

            await this.$api.updateUser({
                id: this.user._id,
                data: {
                    password: this.payload.password,
                }
            })

            setTimeout(() => {
                this.saving = false
                this.$toast('success', 'Usuário atualizado com sucesso!')
            }, 1000)
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: 'load'
        }
    },

}
</script>

<style scoped>
.user-tab-panel__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>
